import {
  createSlice,
  createAsyncThunk,
  combineReducers,
  configureStore,
  AsyncThunkOptions,
} from '@reduxjs/toolkit'
import md5 from 'blueimp-md5'
import store, {
  ActionParams,
  configSlice,
  methods,
  RootState,
  userSlice,
} from '../index'
import { NoteItem, PageItem, CategoryItem } from './typings'
import { Debounce, deepCopy, QueueLoop } from '@nyanyajs/utils'
import { prompt, snackbar, alert } from '@saki-ui/core'
import { v5 as uuidv5, v4 as uuidv4 } from 'uuid'
import { storage } from '../storage'
import { getI18n } from 'react-i18next'
import { api, httpApi } from '../../modules/http/api'
import { protoRoot, LongToNumber } from '../../protos'
import { getSubTodoIds, sortTodoList, todoMethods } from './todolist'
import {
  formatNote,
  getContent,
  getId,
  getSortIndex,
  getNoteByCloud,
  mergeNote,
  saveNote,
  getNoteMergeOrReplaceAlert,
  getNotePermissions,
  cleanNote,
} from './methods'
import moment from 'moment'
import i18n from '../../modules/i18n/i18n'
import { configMethods } from '../config'

const syncRemoteDataDebounce = new Debounce()

const updateNoteDebounce = new Debounce()
const updateTodoDebounce = new Debounce()
const saveNoteDebounce = new Debounce()
const lastSyncTimeDebounce = new Debounce()

const t = i18n.t

export const state = {
  noteId: 'none',
  categoryId: 'none',
  pageId: 'none',
  list: [] as protoRoot.note.INoteItem[],
  permissions: {} as {
    [id: string]: protoRoot.note.INotePermissionsItem[]
  },
  isInit: false,
  updateTime: 0,
  lastSyncTime: 0,
  mustUpdate: false,
  quickReviewSelect: {
    noteId: '',
  },
  pwdObj: {} as {
    [pageId: string]: {
      pwd: string
      validTime: number
    }
  },
  permissionsTemplate: [
    {
      val: 1,
      text: 'onlyView',
    },
    {
      val: 5,
      text: 'editable',
    },
  ],
  collapseTodoIds: [] as string[],
}

export const notesSlice = createSlice({
  name: 'notes',
  initialState: state,
  reducers: {
    init: (
      state,
      params: ActionParams<{
        list: typeof state.list
        noteId: string
        categoryId: string
        pageId: string
      }>
    ) => {
      // console.log('init')
      state.list = cleanNote(params.payload.list.map((v) => formatNote(v)))
      state.list?.sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      // console.log('cleanNote', state.list)

      state.noteId = params.payload.noteId
      state.categoryId = params.payload.categoryId
      state.pageId = params.payload.pageId
      console.log('state.pageId', params, state.pageId)
    },
    // cleanNote: (state) => {
    //   console.log('cleanNote', deepCopy(state.list))
    //   state.list = cleanNote(state.list)
    //   console.log('cleanNote', deepCopy(state.list))
    // },

    setCollapseTodoIds: (
      state,
      params: ActionParams<typeof state.collapseTodoIds>
    ) => {
      state.collapseTodoIds = params.payload || []

      storage.global.setSync('collapseTodoIds', params.payload)
    },
    setIsInit: (state, params: ActionParams<boolean>) => {
      state.isInit = params.payload
    },
    updateNoteTime: (state) => {
      state.updateTime = Math.floor(new Date().getTime() / 1000)
      console.log('updateNoteTime', state.updateTime)
    },
    setPermissions: (state, params: ActionParams<typeof state.permissions>) => {
      state.permissions = params.payload
      console.log('setPermissions', params.payload)
    },
    setPwdObj: (state, params: ActionParams<(typeof state)['pwdObj']>) => {
      Object.keys(params.payload).forEach((id) => {
        if (
          params.payload[id]?.validTime <
          Math.floor(new Date().getTime() / 1000)
        ) {
          delete params.payload[id]
        }
      })

      state.pwdObj = params.payload

      storage.global.setSync('pwdObj', params.payload)
    },
    setQuickReviewSelectData: (
      state,
      params: ActionParams<{
        noteId: string
      }>
    ) => {
      if (!params.payload?.noteId) {
        params.payload = {
          noteId: state.list?.[0]?.id || '',
        }
      }
      state.quickReviewSelect.noteId = params.payload.noteId
      storage.global.setSync('quickReviewSelectData', {
        noteId: params.payload.noteId,
      })
    },
    mergeNoteByCloud: (
      state,
      params: ActionParams<{
        id: string
        v: (typeof state.list)[0]
        type: 'Merge' | 'Replace'
      }>
    ) => {
      const note = formatNote(params.payload.v)
      console.log('---mergeNoteByCloud---', note)

      let isExist = false

      state.list.some((v, i) => {
        if (v.id === params.payload.id) {
          let localUpdate = false
          if (params.payload.type == 'Merge') {
            const nNote = mergeNote(deepCopy(v), note)
            localUpdate = nNote.localUpdate
            state.list[i] = nNote.note
            console.log('mergeNoteByCloud 版本', nNote, note.lastUpdateTime)
          }
          if (params.payload.type == 'Replace') {
            const nNote = mergeNote(deepCopy(v), note)
            state.list[i] = note
            localUpdate = nNote.localUpdate
          }

          state.updateTime = Math.floor(new Date().getTime() / 1000)

          if (state.list[i].isSync && !state.permissions[v.id]) {
            setTimeout(() => {
              getNotePermissions(note.id || '')
            }, 700)
          }

          saveNote({
            id: v.id || '',
            v: state.list[i],
            requestParams: localUpdate
              ? {
                  type: 'Note',
                  methods: 'Update',
                  changedField: ['name', 'categories'],
                  options: {
                    noteId: v.id,
                  },
                  data: {
                    note: state.list[i],
                  },
                }
              : undefined,
          })

          isExist = true
          return true
        }
      })

      state.list = cleanNote(state.list)

      console.log('mergeNoteByCloud 版本22222', deepCopy(state.list))

      state.list?.sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      if (!isExist) {
        if (note.isSync && !state.permissions[note.id || '']) {
          setTimeout(() => {
            getNotePermissions(note.id || '')
          }, 700)
        }
        // console.log('本地不存在', params.payload.v)
        setTimeout(() => {
          store.dispatch(
            notesSlice.actions.addNote({
              v: note,
            })
          )
        })
      }
    },
    setNoteLastUpdateTime: (
      state,
      params: ActionParams<{
        id: string
        lastUpdateTime?: number
        syncTime?: number
      }>
    ) => {
      // console.log('setNoteLastUpdateTime1')
      let note: NoteItem | undefined
      state.list.some((v) => {
        if (v.id === params.payload.id) {
          params.payload.lastUpdateTime &&
            (v.lastUpdateTime = params.payload.lastUpdateTime)
          params.payload.syncTime && (v.syncTime = params.payload.syncTime)

          console.log('setNoteLastUpdateTime2 版本', deepCopy(v))
          storage.notes.setSync(v.id, deepCopy(v))
          return true
        }
      })
    },
    addNote: (
      state,
      params: ActionParams<{
        v: (typeof state.list)[0]
        disableSync?: boolean
      }>
    ) => {
      // console.log(state.list, params)
      if (!params.payload) return
      let isExist = false
      state.list.some((v, i) => {
        if (v.id === params.payload.v.id) {
          isExist = true
          state.list[i] = Object.assign(v, params.payload.v)
          return true
        }
      })
      console.log('isExist', isExist)
      if (!isExist) {
        state.list.push(params.payload.v)

        state.list[state.list.length - 1].sort = state.list.length
      }
      state.noteId = params.payload.v.id || ''
      // console.log(state.list, params)

      state.list?.sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      saveNote({
        id: state.noteId,
        v: params.payload.v,
        requestParams: !params.payload.disableSync
          ? {
              type: 'Note',
              methods: 'Add',
              options: {
                noteId: state.noteId,
              },
              data: {
                note: deepCopy(params.payload.v),
              },
            }
          : undefined,
      })
      storage.global.setSync('selectNote', state.noteId)
    },
    updateNote: (
      state,
      params: ActionParams<{
        noteId: string
        changedField?: string[]
        note: {
          name?: string
          authorId?: string
          categories?: protoRoot.note.ICategoryItem[]
          isSync?: boolean
        }
        disableSync?: boolean
      }>
    ) => {
      let { noteId, note, changedField, disableSync } = params.payload

      if (!changedField) {
        changedField = Object.keys(note)
      }

      console.log('updateNote', params)

      if (!note.name) return
      state.list.some((v) => {
        if (v.id === noteId) {
          if (changedField?.includes('categories')) {
            v.categories = note.categories
          }
          if (changedField?.includes('name')) {
            v.name = note.name || ''
          }
          if (changedField?.includes('authorId')) {
            v.authorId = note.authorId || v.authorId
          }
          if (changedField?.includes('isSync')) {
            v.isSync = note.isSync || v.isSync
          }
          v.lastUpdateTime = Math.floor(new Date().getTime() / 1000)

          saveNote({
            id: v.id,
            v,
            requestParams: !disableSync
              ? {
                  type: 'Note',
                  methods: 'Update',
                  options: {
                    noteId: v.id,
                  },
                  changedField,
                  data: {
                    note: {
                      name: v.name,
                      categories: note.categories,
                      authorId: v.authorId,
                      isSync: v.isSync,
                      lastUpdateTime: v.lastUpdateTime,
                    },
                  },
                }
              : undefined,
          })

          return true
        }
      })
    },
    enableSyncNote: (
      state,
      params: ActionParams<{
        noteId: string
        isSync: boolean
      }>
    ) => {
      const { noteId, isSync } = params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.isSync = isSync
          console.log('enableSyncNote', deepCopy(v))
          // 1. 检测远端是否存在,不存在则添加,存在则不添加

          saveNote({
            id: v.id,
            v,
            requestParams: undefined,
          })

          // 等上面这个完成后再刷新
          // isSync &&
          // 	setTimeout(async () => {
          // 		await store.dispatch(notesMethods.GetRemoteData())
          // 	})

          return true
        }
      })
    },

    saveNoteToThisAccount: (
      state,
      params: ActionParams<{
        noteId: string
        uid: string
      }>
    ) => {
      console.log('saveNoteToThisAccount')
      // 存储至本账号的时候，检测是否有同样id的分类，如果有，
      // 询问用户是否合并两个笔记。不合并就全新创建(分类与页面的id也是新的)
      // 合并的时候，id用之前的id。
      // 这样就可以将本来的内容并在一起了,合并采用更新

      const { noteId, uid } = params.payload
      const note: (typeof state.list)[0] = deepCopy(
        state.list.filter((v) => v.id === noteId)?.[0]
      )
      const categoryIds =
        note.categories?.map((v) => {
          return v?.id || ''
        }) || []
      console.log(deepCopy(note))
      console.log(deepCopy(categoryIds))

      let nindex = -1
      let cNote: (typeof state.list)[0]
      state.list.forEach((v, i) => {
        if (v.authorId === uid) {
          v.categories?.some((sv) => {
            console.log(categoryIds.includes(sv?.id || ''), v.name, sv.id)
            if (categoryIds.includes(sv?.id || '')) {
              nindex = i
              return true
            }
          })
        }
        return nindex >= 0
      })
      console.log('nindex', nindex >= -1, nindex)
      if (nindex >= 0) {
        cNote = deepCopy(state.list[nindex])
      }
      const saveNote = (merge: boolean) => {
        setTimeout(() => {
          console.log('merge', merge)
          const { user } = store.getState()
          note.authorId = user.userInfo.uid
          if (merge) {
            // note.id = cNote.id
            // let categories: CategoryItem[] = []
            // cNote.categories.forEach((v) => {
            // 	const isExist = note.categories.filter((sv) => {
            // 		return sv.id === v.id
            // 	})
            // 	if (!isExist) {
            // 		categories.push(v)
            // 	}
            // })
            // console.log(categories)
            // note.categories = note.categories.concat(categories)
            // // 更新
            // store.dispatch(
            // 	notesSlice.actions.updateNote({
            // 		noteId: note.id,
            // 		note: {
            // 			name: note.name,
            // 			authorId: note.authorId,
            // 			isSync: note.isSync,
            // 		},
            // 		disableSync: false,
            // 	})
            // )
          } else {
            note.id = getId()
            note.categories?.forEach((v) => {
              v.id = getId()
              v.data?.forEach((sv) => {
                sv.id = getId()
                sv.todoList?.forEach((ssv) => {
                  ssv.id = getId()
                })
              })
            })
            store.dispatch(
              notesSlice.actions.addNote({
                v: note,
              })
            )
            // 另存
          }

          // 删除原noteId
          store.dispatch(
            notesSlice.actions.deleteNote({
              noteId: noteId,
            })
          )
          console.log(note)
          console.log(cNote)
        })
      }
      if (nindex >= 0) {
        // 合并数据以后再说

        // 询问是否合并
        // alert({
        // 	title: '合并数据',
        // 	content:
        // 		'检测到与「' +
        // 		state.list[nindex].name +
        // 		'」可能是同一个数据内容,需要合并数据吗?',
        // 	cancelText: 'Save as',
        // 	confirmText: 'Merge',
        // 	onCancel() {
        // 		saveNote(false)
        // 	},
        // 	async onConfirm() {
        // 		saveNote(true)
        // 	},
        // }).open()
        saveNote(false)
        return
      }
      saveNote(false)
      // 无需合并
      // if (!note.name) return
      // state.list.some((v) => {
      // 	if (v.id === noteId) {
      // 		v.name = note.name || ''
      // 		v.lastUpdateTime = Math.floor(new Date().getTime() / 1000)
      // 		saveNote({
      // 			id: v.id,
      // 			v,
      // 			requestParams: !disableSync
      // 				? {
      // 						type: 'Note',
      // 						methods: 'Update',
      // 						options: {
      // 							noteId: v.id,
      // 						},
      // 						data: {
      // 							note: {
      // 								name: note.name,
      // 								lastUpdateTime: v.lastUpdateTime,
      // 							},
      // 						},
      // 				  }
      // 				: undefined,
      // 		})

      // 		return true
      // 	}
      // })
    },

    deleteNote: (
      state,
      params: ActionParams<{
        noteId: string
        data?: {
          deleteTime: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, data, disableSync } = params.payload
      if (!noteId) return

      state.list.some((v, i) => {
        if (v.id === noteId) {
          let selectNoteId = state.list?.[i >= 1 ? i - 1 : 0]?.id || ''

          v.status = -1
          const dt = data?.deleteTime || Math.floor(new Date().getTime() / 1000)
          v.deleteTime = dt
          v.lastUpdateTime = dt
          state.list = cleanNote(state.list.filter((v) => v.id !== noteId))

          storage.notes.delete(v.id).then(() => {
            !disableSync &&
              api.v1
                .syncToServer({
                  type: 'Note',
                  methods: 'Delete',
                  options: {
                    noteId,
                  },
                  data: {
                    note: {
                      deleteTime: dt,
                    },
                  },
                })
                .then((res) => {
                  console.log('deletenote', res)
                  store.dispatch(
                    notesSlice.actions.selectNote({
                      id: selectNoteId,
                    })
                  )
                })
          })

          return true
        }
      })
    },
    addCategory: (
      state,
      params: ActionParams<{
        noteId: string
        category: protoRoot.note.ICategoryItem
        disableSync?: boolean
      }>
    ) => {
      const { category, noteId, disableSync } = params.payload
      state.list.some((v) => {
        if (v.id === noteId && v.categories) {
          v.categories.push(category)
          state.categoryId = category.id || ''

          v.categories[v.categories.length - 1].sort = v.categories.length

          saveNote({
            id: v.id,
            v,
            requestParams: !disableSync
              ? {
                  type: 'Category',
                  methods: 'Add',
                  options: {
                    noteId: v.id,
                    categoryId: category.id,
                  },
                  data: {
                    category: deepCopy(category),
                  },
                }
              : undefined,
          })
          storage.global.setSync('selectCategory', state.categoryId)
          return true
        }
      })
    },
    updateCategory: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        category: {
          name?: string
          data?: protoRoot.note.IPageItem[]
          lastUpdateTime?: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, category, categoryId, disableSync } = params.payload

      console.log('updateCategory', { ...params })
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              // console.log('categiory', category)
              // console.log({ ...sv })
              sv.lastUpdateTime =
                category.lastUpdateTime ||
                Math.floor(new Date().getTime() / 1000)
              sv = Object.assign(sv, category)
              category.lastUpdateTime = sv.lastUpdateTime || 0
              console.log('updateCategory', { ...sv })
              saveNote({
                id: v?.id || '',
                v,
                requestParams: !disableSync
                  ? {
                      type: 'Category',
                      methods: 'Update',
                      options: {
                        noteId: v.id,
                        categoryId: sv.id,
                      },
                      data: {
                        category: Object.assign({}, category),
                      },
                    }
                  : undefined,
              })
              return true
            }
          })

          return true
        }
      })
    },

    changePageCategoryTo: (
      state,
      params: ActionParams<{
        noteId: string
        pageId: string
        oldCategoryId: string
        newCategoryId: string
        disableSync?: boolean
      }>
    ) => {
      const { noteId, pageId, oldCategoryId, newCategoryId, disableSync } =
        params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === oldCategoryId) {
              sv.data?.some((ssv) => {
                if (ssv.id === pageId) {
                  v.categories?.some((sssv) => {
                    if (sssv.id === newCategoryId && sssv.data) {
                      console.log(deepCopy(sssv), 'cccccccccccccccccccc')
                      sssv.data.push(ssv)
                      sssv.lastUpdateTime = Math.floor(
                        new Date().getTime() / 1000
                      )

                      saveNote({
                        id: v?.id || '',
                        v,
                        requestParams: !disableSync
                          ? {
                              type: 'Category',
                              methods: 'Update',
                              options: {
                                noteId,
                                categoryId: newCategoryId,
                              },
                              data: {
                                category: Object.assign({}, sssv),
                              },
                            }
                          : undefined,
                      })
                      return true
                    }
                  })
                  sv.data = sv.data?.filter((sssv) => sssv.id !== pageId) || []
                  sv.lastUpdateTime = Math.floor(new Date().getTime() / 1000)

                  saveNote({
                    id: v.id || '',
                    v,
                    requestParams: !disableSync
                      ? {
                          type: 'Category',
                          methods: 'Update',
                          options: {
                            noteId,
                            categoryId: oldCategoryId,
                          },
                          data: {
                            category: Object.assign({}, sv),
                          },
                        }
                      : undefined,
                  })
                }
              })

              return true
            }
          })

          return true
        }
      })
    },
    deleteCategory: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        data?: {
          deleteTime: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { categoryId, noteId, data, disableSync } = params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv, si) => {
            if (sv.id === categoryId) {
              if (state.categoryId === categoryId) {
                state.categoryId =
                  v.categories?.[si - 1 >= 0 ? si - 1 : 0]?.id || ''
                storage.global.setSync('selectCategory', state.categoryId)

                if (state.categoryId) {
                  state.pageId =
                    v.categories?.[si - 1 >= 0 ? si - 1 : 0].data?.[0]?.id ||
                    'none'
                  storage.global.setSync('selectPage', state.pageId)
                }
              }

              sv.status = -1
              sv.deleteTime =
                data?.deleteTime || Math.floor(new Date().getTime() / 1000)
              sv.lastUpdateTime = sv.deleteTime

              saveNote({
                id: v.id || '',
                v: deepCopy(v),
                requestParams: !disableSync
                  ? {
                      type: 'Category',
                      methods: 'Delete',
                      options: {
                        noteId: v.id,
                        categoryId: categoryId,
                      },
                      data: {
                        category: {
                          deleteTime: sv.deleteTime,
                        },
                      },
                    }
                  : undefined,
              })
              return true
            }
          })

          return true
        }
      })
    },
    addPage: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        page: protoRoot.note.IPageItem
        disableSync?: boolean
      }>
    ) => {
      const { categoryId, noteId, page, disableSync } = params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId && sv.data) {
              page.sort = sv.data.length
              sv.data.push(page)

              state.pageId = page.id || ''
              console.log('addPage', page, deepCopy(v))

              saveNote({
                id: v.id || '',
                v,
                requestParams: !disableSync
                  ? {
                      type: 'Page',
                      methods: 'Add',
                      options: {
                        noteId: v.id,
                        categoryId: sv.id,
                        pageId: page.id,
                      },
                      data: {
                        page: { ...page },
                      },
                    }
                  : undefined,
              })
              storage.global.setSync('selectPage', page.id)
              return true
            }
          })

          return true
        }
      })
    },
    updatePage: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        changedField?: string[]
        data: {
          title?: string
          content?: string
          encryption?: 2 | 1 | -1
          labels?: protoRoot.note.PageItem.ILabelItem[]
          // type?: PageItem['type']
          lastUpdateTime?: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, categoryId, pageId, data, disableSync } = params.payload
      // console.log("updatePage", deepCopy(params))

      let changedField = params.payload.changedField

      if (!changedField) {
        changedField = Object.keys(data)
      }

      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv) => {
                // console.log('pageupdate', deepCopy(ssv), pageId)
                if (ssv.id === pageId) {
                  // ssv = Object.assign(ssv, params.payload)
                  // data.title &&
                  // 	(ssv.title =
                  // 		data.title.replace("'__nonec__xxx1,df,a", '') || '')
                  // data.content && (ssv.content = data.content || '')
                  // data.title !== '__nonec__xxx1,df,a' && (ssv.title = '')
                  // data.content !== '__nonec__xxx1,df,a' && (ssv.content = '')

                  if (changedField?.includes('title')) {
                    ssv.title = data.title || ''
                  }
                  if (changedField?.includes('content')) {
                    ssv.content = data.content || ''
                  }

                  if (changedField?.includes('encryption')) {
                    ssv.encryption = data.encryption
                  }
                  if (changedField?.includes('labels')) {
                    ssv.labels = data.labels
                  }

                  // if (data?.type) {
                  //   ssv.type = data.type
                  // }
                  // state.pageId = page.id
                  // console.log(JSON.parse(JSON.stringify(ssv)))
                  // console.log('update')
                  if (disableSync) {
                    state.mustUpdate = true
                  } else {
                    state.mustUpdate = false
                  }
                  console.log('mergeObj1', deepCopy(ssv))

                  ssv.lastUpdateTime =
                    data.lastUpdateTime ||
                    Math.floor(new Date().getTime() / 1000)

                  console.log(
                    'mergeObj2',
                    ssv.lastUpdateTime,
                    deepCopy(v),
                    data,
                    changedField
                  )
                  // console.log('page222', deepCopy(ssv), data, pageId)
                  const saveNoteParams = deepCopy({
                    id: v?.id || '',
                    v: deepCopy(v) as protoRoot.note.INoteItem,
                    requestParams: !disableSync
                      ? {
                          type: 'Page',
                          methods: 'Update',
                          changedField,
                          options: {
                            noteId: v.id,
                            categoryId: sv.id,
                            pageId: ssv.id,
                          },
                          data: {
                            page: {
                              title: data.title,
                              content: data.content,
                              encryption: ssv.encryption,
                              labels: ssv.labels,
                              // type: data.type || ssv.type,
                              lastUpdateTime: ssv.lastUpdateTime,
                            },
                          },
                        }
                      : undefined,
                  })
                  updateNoteDebounce.increase(() => {
                    console.log('update1', saveNoteParams)
                    saveNote(saveNoteParams)
                  }, 700)
                  return true
                }
              })
              return true
            }
          })

          return true
        }
      })
    },
    setLastSyncTime: (state, params: ActionParams<number>) => {
      state.lastSyncTime = params.payload
    },
    deletePage: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        data?: {
          deleteTime: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, categoryId, pageId, data, disableSync } = params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv, ssi) => {
                if (ssv.id === pageId) {
                  if (state.pageId === pageId) {
                    state.pageId =
                      sv.data?.[ssi - 1 >= 0 ? ssi - 1 : 0]?.id || ''
                    storage.global.setSync('selectPage', state.pageId)
                  }

                  ssv.status = -1
                  ssv.deleteTime =
                    data?.deleteTime || Math.floor(new Date().getTime() / 1000)
                  ssv.lastUpdateTime = ssv.deleteTime

                  saveNote({
                    id: v.id || '',
                    v: deepCopy(v),
                    requestParams: !disableSync
                      ? {
                          type: 'Page',
                          methods: 'Delete',
                          options: {
                            noteId: v.id,
                            categoryId: sv.id,
                            pageId: pageId,
                          },
                          data: {
                            page: {
                              deleteTime: ssv.deleteTime,
                            },
                          },
                        }
                      : undefined,
                  })
                  return true
                }
              })
            }
            return sv.id === categoryId
          })
        }
        return v.id === noteId
      })
    },

    selectNote: (
      state,
      params: ActionParams<{
        id: string
        isInit?: boolean
      }>
    ) => {
      let { id } = params.payload
      if (id === 'none') {
        state.noteId = 'none'
        state.categoryId = 'none'
        state.pageId = 'none'
        storage.global.setSync('selectNote', '')
        storage.global.setSync('selectPage', '')
        storage.global.setSync('selectCategory', '')
        return
      }
      if (!id) {
        if (state.list.length) {
          id = state.list[0].id || ''
        }
      }
      state.list.some((v) => {
        if (v.id === id) {
          const categories =
            v.categories?.filter((v) => (v.status || 0) >= 0) || []
          if (categories?.[0]) {
            state.categoryId = categories?.[0]?.id || ''
            storage.global.setSync('selectCategory', state.categoryId)
            const pages =
              categories?.[0]?.data?.filter((v) => (v.status || 0) >= 0) || []
            if (pages?.[0]) {
              state.pageId = pages?.[0]?.id || ''
              storage.global.setSync('selectPage', state.pageId)
            }
          }
          state.noteId = id
          storage.global.setSync('selectNote', state.noteId)

          return true
        }
      })
    },
    selectCategory: (
      state,
      params: ActionParams<{
        id: string
        isInit?: boolean
      }>
    ) => {
      let { id } = params.payload

      if (!id) {
        storage.global.setSync('selectPage', '')
        storage.global.setSync('selectCategory', '')
        return
      }
      if (state.categoryId === id) return
      state.categoryId = id
      storage.global.setSync('selectCategory', state.categoryId)
      state.list.some((v) => {
        if (v.id === state.noteId) {
          v.categories?.some((sv) => {
            if (sv.id === state.categoryId) {
              const pages = sv.data?.filter((v) => (v.status || 0) >= 0) || []
              state.pageId = pages?.[0]?.id || ''
              storage.global.setSync('selectPage', state.pageId)
              return true
            }
          })
          return true
        }
      })
    },
    selectPage: (
      state,
      params: ActionParams<{
        id: string
      }>
    ) => {
      const { id } = params.payload
      if (state.pageId === id) return
      state.pageId = id
      // console.log(id)
      storage.global.getAndSet('selectPage', async (v) => {
        // console.log('v', storage.global, 'v', v, 'id', id)
        return id
      })
    },
    sortNote: (
      state,
      params: ActionParams<{
        sort?: protoRoot.note.ISortItem
        disableSync?: boolean
      }>
    ) => {
      let { sort, disableSync } = params.payload

      if (!sort) return

      let { originalIndex, targetIndex } = sort

      // console.log(originalIndex, targetIndex)

      if (!sort.list?.length) {
        if (originalIndex === targetIndex) return
        originalIndex = getSortIndex(state.list, originalIndex || 0)
        targetIndex = getSortIndex(state.list, targetIndex || 0)

        if (originalIndex < targetIndex) {
          for (let i = originalIndex; i < targetIndex; i++) {
            // console.log(i, i + 1)
            // sorts[i].sort = sorts[i + 1].sort
            // sorts[i + 1].sort = sorts[i].sort
            ;[state.list[i], state.list[i + 1]] = [
              state.list[i + 1],
              state.list[i],
            ]
          }
        } else {
          for (let i = originalIndex; i > targetIndex; i--) {
            // console.log(i, i - 1)
            // sorts[i].sort = sorts[i - 1].sort
            // sorts[i - 1].sort = sorts[i].sort
            ;[state.list[i], state.list[i - 1]] = [
              state.list[i - 1],
              state.list[i],
            ]
          }
        }

        state.list.forEach((v, i) => {
          console.log('v.sort !== i + 1', v.sort, i + 1)
          if (v.sort !== i + 1) {
            v.lastUpdateTime = Math.floor(new Date().getTime() / 1000)
          }
          v.sort = i + 1
        })

        // console.log(
        // 	state.list.map((v) => {
        // 		return {
        // 			id: v.id,
        // 			sort: v.sort,
        // 		}
        // 	})
        // )
      } else {
        const sortListObj = Object.fromEntries(
          sort.list.map((v) => {
            return [v.id, v]
          })
        )
        state.list.forEach((v) => {
          v.sort = sortListObj[v.id || '']?.sort || v.sort
        })
      }

      state.list.sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })

      console.log('state.list', deepCopy(state.list))
      if (!disableSync) {
        let ids = state.list
          .filter((v) => v.isSync)
          .map((v) => {
            saveNote({
              id: v?.id || '',
              v,
            })
            return {
              id: v.id,
              sort: v.sort,
              lastUpdateTime: v.lastUpdateTime,
            }
          })
        setTimeout(() => {
          api.v1
            .syncToServer({
              type: 'Note',
              methods: 'Sort',
              options: {},
              data: {
                sort: {
                  originalIndex,
                  targetIndex,
                  list: ids,
                },
              },
            })
            .then((res) => {
              console.log(res)
            })
        })
      }
    },
    sortCategory: (
      state,
      params: ActionParams<{
        noteId: string
        lastUpdateTime?: number
        sort?: protoRoot.note.ISortItem
        disableSync?: boolean
      }>
    ) => {
      let { noteId, lastUpdateTime, sort, disableSync } = params.payload

      if (!sort) return

      let { originalIndex, targetIndex } = sort
      if (originalIndex === targetIndex) return

      // storage.global.setSync('selectCategory', state.categoryId)
      state.list.some((v) => {
        if (v.id === noteId && v.categories && sort) {
          if (!sort.list?.length) {
            originalIndex = getSortIndex(v.categories, originalIndex || 0)
            targetIndex = getSortIndex(v.categories, targetIndex || 0)
            if (originalIndex < targetIndex) {
              for (let i = originalIndex; i < targetIndex; i++) {
                ;[v.categories[i], v.categories[i + 1]] = [
                  v.categories[i + 1],
                  v.categories[i],
                ]
              }
            } else {
              for (let i = originalIndex; i > targetIndex; i--) {
                ;[v.categories[i], v.categories[i - 1]] = [
                  v.categories[i - 1],
                  v.categories[i],
                ]
              }
            }
            v.categories.forEach((sv, i) => {
              sv.sort = (v.categories?.length || 0) - i
            })

            v.categories.sort((a, b) => (b.sort || 0) - (a.sort || 0))
          } else {
            const cateObj = Object.fromEntries(
              v.categories.map((v) => {
                return [v.id, v]
              })
            )
            v.categories = sort.list.map((v) => {
              const cate = cateObj[v.id || '']
              cate.sort = v.sort
              return cate
            })
          }

          v.lastUpdateTime =
            lastUpdateTime || Math.floor(new Date().getTime() / 1000)

          saveNote({
            id: v.id,
            v,
            requestParams: !disableSync
              ? {
                  type: 'Category',
                  methods: 'Sort',
                  options: {
                    noteId: v.id,
                  },
                  data: {
                    note: {
                      lastUpdateTime: v.lastUpdateTime,
                    },
                    sort: {
                      originalIndex,
                      targetIndex,
                      list: v.categories.map((v) => {
                        return {
                          id: v.id,
                          sort: v.sort,
                        }
                      }),
                    },
                  },
                }
              : undefined,
          })
          return true
        }
      })
    },
    sortPage: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        lastUpdateTime?: number
        sort?: protoRoot.note.ISortItem
        disableSync?: boolean
      }>
    ) => {
      let { noteId, categoryId, lastUpdateTime, sort, disableSync } =
        params.payload

      if (!sort) return

      let { originalIndex, targetIndex } = sort

      if (originalIndex === targetIndex) return

      // storage.global.setSync('selectCategory', state.categoryId)
      state.list
        .filter((v) => (v.status || 0) >= 0)
        .some((v) => {
          if (v.id === noteId && v.categories) {
            v.categories
              .filter((v) => (v.status || 0) >= 0)
              .some((sv) => {
                if (sv.id === categoryId && sv.data && sort) {
                  if (!sort.list?.length) {
                    originalIndex = getSortIndex(sv.data, originalIndex || 0)
                    targetIndex = getSortIndex(sv.data, targetIndex || 0)

                    if (originalIndex < targetIndex) {
                      for (let i = originalIndex; i < targetIndex; i++) {
                        ;[sv.data[i], sv.data[i + 1]] = [
                          sv.data[i + 1],
                          sv.data[i],
                        ]
                      }
                    } else {
                      for (let i = originalIndex; i > targetIndex; i--) {
                        ;[sv.data[i], sv.data[i - 1]] = [
                          sv.data[i - 1],
                          sv.data[i],
                        ]
                      }
                    }

                    sv.data.forEach((v, i) => {
                      v.sort = (sv.data?.length || 0) - i
                    })

                    sv.data.sort((a, b) => (b.sort || 0) - (a.sort || 0))
                  } else {
                    const pagesObj = Object.fromEntries(
                      sv.data.map((v) => {
                        return [v.id, v]
                      })
                    )
                    sv.data = sort.list.map((v) => {
                      const page = pagesObj[v.id || '']
                      page.sort = v.sort
                      return page
                    })
                  }
                  sv.lastUpdateTime =
                    lastUpdateTime || Math.floor(new Date().getTime() / 1000)

                  saveNote({
                    id: v?.id || '',
                    v,
                    requestParams: !disableSync
                      ? {
                          type: 'Page',
                          methods: 'Sort',
                          options: {
                            noteId: v.id,
                            categoryId: sv.id,
                          },
                          data: {
                            category: {
                              lastUpdateTime: sv.lastUpdateTime,
                            },
                            sort: {
                              originalIndex,
                              targetIndex,
                              list: sv.data.map((v) => {
                                return {
                                  id: v.id,
                                  sort: v.sort,
                                }
                              }),
                            },
                          },
                        }
                      : undefined,
                  })
                  return true
                }
              })
            return true
          }
        })
    },
    // todolist
    addTodo: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        todo: protoRoot.note.ITodoListPageItem
        disableSync?: boolean
      }>
    ) => {
      const { categoryId, noteId, pageId, todo, disableSync } = params.payload
      console.log('addTodo', params)
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv) => {
                if (ssv.id === pageId && ssv.type === 'TodoList') {
                  if (!ssv.todoList?.length) {
                    ssv.todoList = []
                  }
                  todo.status = 0
                  ssv.todoList = ssv.todoList.concat(todo)

                  ssv.lastUpdateTime = todo.lastUpdateTime

                  sortTodoList(ssv.todoList)
                  console.log(
                    'ssv.todoList',
                    ssv.todoList.map((v) => v.id)
                  )

                  saveNote(
                    deepCopy({
                      id: v.id || '',
                      v,
                      requestParams: !disableSync
                        ? {
                            type: 'TodoList',
                            methods: 'Add',
                            options: {
                              noteId: v.id,
                              categoryId: sv.id,
                              pageId: ssv.id,
                              todoId: todo.id,
                            },
                            data: {
                              todo: deepCopy(todo),
                              page: {
                                lastUpdateTime: ssv.lastUpdateTime,
                              },
                              sort: {
                                list: ssv.todoList.map((todo) => {
                                  return {
                                    id: todo.id,
                                    sort: todo.sort,
                                    parentId: todo.parentId,
                                  }
                                }),
                              },
                            },
                          }
                        : undefined,
                    })
                  )

                  return true
                }
              })
              return true
            }
          })

          return true
        }
      })
    },
    updateTodo: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        todoId: string
        data: {
          title?: string
          note?: string
          status?: 1 | 0 | -1
          parentId?: string
          labelId?: string
          disable?: 1 | -1
          importance?: 5 | 4 | 3 | 2 | 1 | 0
          lastUpdateTime?: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, categoryId, pageId, todoId, data, disableSync } =
        params.payload
      // console.log("updatePage", deepCopy(params))
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv) => {
                if (ssv.id === pageId && ssv.type === 'TodoList') {
                  ssv.todoList?.some((sssv) => {
                    if (sssv.id === todoId && ssv.todoList) {
                      let isSort = false
                      if (!data.hasOwnProperty('title')) {
                        data.title = '__{none}__'
                      }
                      if (!data.hasOwnProperty('note')) {
                        data.note = '__{none}__'
                      }

                      if (data.title !== '__{none}__') {
                        sssv.title = data.title || ''
                      }
                      if (data.note !== '__{none}__') {
                        sssv.note = data.note || ''
                      }
                      if (data.hasOwnProperty('status')) {
                        sssv.status = data.status || 0
                        isSort = true
                      }
                      if (data.hasOwnProperty('labelId')) {
                        sssv.labelId =
                          data.labelId === 'none' ? '' : data.labelId
                      }
                      if (data.hasOwnProperty('parentId')) {
                        sssv.parentId = data.parentId || sssv.parentId
                        isSort = true
                      }
                      if (data.hasOwnProperty('disable')) {
                        sssv.disable = data.disable
                      }
                      if (data.hasOwnProperty('importance')) {
                        sssv.importance = data.importance || 0
                        isSort = true
                      }

                      sssv.lastUpdateTime =
                        data?.lastUpdateTime ||
                        Math.floor(new Date().getTime() / 1000)

                      ssv.lastUpdateTime = sssv.lastUpdateTime

                      if (isSort) {
                        sortTodoList(ssv.todoList, true)
                      }

                      console.log(
                        'datadata',
                        data,
                        deepCopy(sssv),
                        deepCopy(data)
                      )

                      const saveNotePayload = deepCopy({
                        id: v?.id || '',
                        v: v,
                        requestParams: !disableSync
                          ? {
                              type: 'TodoList',
                              methods: 'Update',
                              options: {
                                noteId: v.id,
                                categoryId: sv.id,
                                pageId: ssv.id,
                                todoId: sssv.id,
                              },
                              data: {
                                todo: {
                                  title: data.title,
                                  note: data.note,
                                  status: sssv.status,
                                  parentId: sssv.parentId,
                                  importance: sssv.importance,
                                  labelId: sssv.labelId,
                                  disable: sssv.disable,
                                  lastUpdateTime: sssv.lastUpdateTime,
                                },
                                page: {
                                  lastUpdateTime: ssv.lastUpdateTime,
                                },
                                sort: {
                                  list: ssv.todoList?.map((todo) => {
                                    return {
                                      id: todo.id,
                                      sort: todo.sort,
                                      parentId: todo.parentId,
                                    }
                                  }),
                                },
                              },
                            }
                          : undefined,
                      })

                      updateTodoDebounce.increase(() => {
                        saveNote(saveNotePayload)
                      }, 700)
                      return true
                    }
                  })
                  return true
                }
              })
              return true
            }
          })

          return true
        }
      })
    },
    deleteTodo: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        todoId: string
        data?: {
          deleteTime: number
        }
        disableSync?: boolean
      }>
    ) => {
      const { noteId, categoryId, pageId, todoId, data, disableSync } =
        params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv) => {
                if (
                  ssv.id === pageId &&
                  ssv.type === 'TodoList' &&
                  ssv.todoList
                ) {
                  const subIds = getSubTodoIds(ssv.todoList, todoId).concat([
                    todoId,
                  ])

                  const dt =
                    data?.deleteTime || Math.floor(new Date().getTime() / 1000)
                  ssv.todoList?.forEach((sssv) => {
                    if (subIds.includes(sssv.id || '') && ssv.todoList) {
                      sssv.status = -1
                      sssv.deleteTime = dt
                      sssv.lastUpdateTime = sssv.deleteTime

                      return true
                    }
                  })
                  ssv.lastUpdateTime = dt

                  saveNote({
                    id: v?.id || '',
                    v: deepCopy(v),
                    requestParams: !disableSync
                      ? {
                          type: 'TodoList',
                          methods: 'Delete',
                          options: {
                            noteId: v.id,
                            categoryId: sv.id,
                            pageId: ssv.id,
                            todoId: todoId,
                          },
                          data: {
                            todo: {
                              deleteTime: dt,
                            },
                            page: {
                              lastUpdateTime: ssv.lastUpdateTime,
                            },
                          },
                        }
                      : undefined,
                  })
                  return true
                }
              })
              return true
            }
          })

          return true
        }
      })
    },
    sortTodo: (
      state,
      params: ActionParams<{
        noteId: string
        categoryId: string
        pageId: string
        lastUpdateTime?: number
        sort: {
          list: protoRoot.note.SortItem.IListItem[]
        }
        disableSync?: boolean
      }>
    ) => {
      let { noteId, categoryId, pageId, lastUpdateTime, sort, disableSync } =
        params.payload
      state.list.some((v) => {
        if (v.id === noteId) {
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              sv.data?.some((ssv) => {
                if (ssv.id === pageId && ssv.type === 'TodoList') {
                  if (ssv.todoList && sort?.list?.length) {
                    let todoList: protoRoot.note.ITodoListPageItem[] = []
                    sort?.list?.forEach((sssv) => {
                      const todo = ssv.todoList?.filter(
                        (ssssv) => ssssv.id === sssv.id
                      )?.[0]
                      if (todo) {
                        todo.sort = sssv.sort
                        todo.parentId = sssv.parentId
                        todoList.push(todo)
                      }
                    })

                    ssv.todoList = todoList
                  }

                  ssv.lastUpdateTime =
                    lastUpdateTime || Math.floor(new Date().getTime() / 1000)
                  console.log('datadata SortTodo', deepCopy(ssv.todoList), sort)

                  saveNote({
                    id: v?.id || '',
                    v: deepCopy(v),
                    requestParams: !disableSync
                      ? {
                          type: 'TodoList',
                          methods: 'Sort',
                          options: {
                            noteId: v.id,
                            categoryId: sv.id,
                            pageId: ssv.id,
                          },
                          data: {
                            page: {
                              lastUpdateTime: ssv.lastUpdateTime,
                            },
                            sort: {
                              list: sort?.list,
                            },
                          },
                        }
                      : undefined,
                  })
                  return true
                }
              })
              return true
            }
          })

          return true
        }
      })
    },
  },
})

export const notesMethods = {
  ...todoMethods,
  Init: createAsyncThunk<
    void,
    void,
    {
      state: RootState
    }
  >('notes/Init', async (_, thunkAPI) => {
    // console.log('InitInit')

    store.dispatch(
      notesSlice.actions.setPwdObj((await storage.global.get('pwdObj')) || {})
    )
    store.dispatch(
      notesSlice.actions.setCollapseTodoIds(
        (await storage.global.get('collapseTodoIds')) || []
      )
    )
    // setInterval(() => {
    // 	// thunkAPI.dispatch(notesMethods.GetRemoteData()).unwrap()
    // }, 60 * 1000)
    // syncRemoteDataDebounce.increase(async () => {
    // 	const { user, config } = store.getState()
    // 	// await store.dispatch(notesMethods.GetLocalData())
    // 	// config.networkStatus &&
    // 	// 	(await store.dispatch(notesMethods.GetRemoteData()))
    // 	// store.dispatch(notesSlice.actions.setIsInit(true))
    // }, 200)
  }),
  GetLocalData: createAsyncThunk('notes/GetLocalData', async (_, thunkAPI) => {
    console.log('------GetLocalData------')
    const { config, notes, user } = store.getState()

    const res = await storage.notes.getAll()

    console.log('selectNote', res, await storage.global.get('selectNote'))

    // console.log('notes', storage.notes)
    if (res?.length) {
      store.dispatch(
        notesSlice.actions.init({
          list: res.map((v) => {
            return v.value
          }),
          noteId: (await storage.global.get('selectNote')) || 'none',
          categoryId: (await storage.global.get('selectCategory')) || 'none',
          pageId: (await storage.global.get('selectPage')) || 'none',
        })
      )
      store.dispatch(
        notesSlice.actions.setQuickReviewSelectData(
          await storage.global.get('quickReviewSelectData')
        )
      )
    }
    store.dispatch(
      configSlice.actions.setStatus({
        type: 'noteInitStatus',
        v: true,
      })
    )
    store.dispatch(notesSlice.actions.setIsInit(true))
  }),
  GetRemoteData: createAsyncThunk(
    'notes/GetRemoteData',
    async (_, thunkAPI) => {
      console.log('------GetRemoteData------')
      const { config, notes, user } = store.getState()
      if (!notes.isInit) {
        console.log('本地還未初始化')
        return
      }
      if (!config.sync) {
        console.log('未开启同步功能')
        return
      }
      if (!config.networkStatus) {
        console.log('没网')
        return
      }
      if (!user.isLogin) {
        console.log('未登录')
        return
      }
      console.log('开始了同步功能')

      await store.dispatch(methods.notes.GetCollaborativeNotes())

      store.dispatch(
        configSlice.actions.setStatus({
          type: 'syncStatus',
          v: true,
        })
      )

      // 1、获取所有的note列表以及其url
      // 检测准确的最新更新时间
      let files = await api.v1.getFolderFiles({})

      console.log('getFolderFiles', deepCopy(files))
      let total: any = files.data?.total
      if (files.code === 200) {
        files.data?.list?.forEach((v) => {
          if (v?.id && v.urls?.domainUrl && v.urls?.url) {
            //
            // console.log(notes.list)
            let isExist = false
            let note: protoRoot.note.INoteItem | undefined

            notes.list.some((sv) => {
              if (sv.id === v.id) {
                isExist = true
                note = sv
                return true
              }
            })
            console.log(
              'localLastUpdateTime',
              note?.lastUpdateTime,
              v.lastUpdateTime,
              note?.authorId,
              note?.isSync
            )

            // // 本地存在\更新
            if (isExist && note?.lastUpdateTime) {
              //
              if (note.authorId === user.userInfo.uid && note.isSync) {
                // 更新时间每次和saass同步
                console.log(
                  note.name,
                  ' => 存在,版本是否一致?',
                  note?.lastUpdateTime,
                  v.lastUpdateTime,
                  note.lastUpdateTime - Number(v.lastUpdateTime),
                  moment(note.lastUpdateTime * 1000).format('hh:mm:ss'),
                  moment((v.lastUpdateTime || 0) * 1000).format('hh:mm:ss'),
                  Number(v.lastUpdateTime) > note.lastUpdateTime
                )
                if (Number(v.lastUpdateTime) > note.lastUpdateTime) {
                  console.log('远程版本大于本地 ssv.todoList', note.name)
                  // getNoteByCloud(v.id)
                } else if (Number(v.lastUpdateTime) === note?.lastUpdateTime) {
                  console.log('已经是最新版本了 ssv.todoList', note.name)
                } else {
                  console.log('远程版本小于本地 ssv.todoList', note.name)
                  // saveNote({
                  //   id: note?.id || "",
                  //   v: note,
                  //   requestParams: {
                  //     type: 'Note',
                  //     methods: 'Update',
                  //     options: {
                  //       noteId: note.id,
                  //     },
                  //     data: {
                  //       note: deepCopy(note),
                  //     },
                  //   },
                  // })
                }

                // 新版，开了isSync的每次都要拉取
                getNoteByCloud(v.id)
              } else {
                if (note.authorId !== user.userInfo.uid) {
                  console.log('这是其他人的日记')
                }
                console.log(note.name, ' => 禁用同步')
              }
            }
            // 本地不存在\添加
            else {
              console.log('远端存在,同步到本地', v)
              getNoteByCloud(v.id)
            }
          } else {
          }
        })

        notes.list.forEach((v) => {
          let isExist = false
          files.data?.list?.some((sv) => {
            if (v.id === sv.id) {
              isExist = true
              return true
            }
          })
          // 本地存在\远端不存在
          if (!isExist && v.isSync && v.authorId === user.userInfo.uid) {
            console.log('本地存在远端不存在', 1, deepCopy(v))
            // 如果已经上传过远端,则视为删除,没有则视为本地创建未上传
            if (v.syncTime) {
              console.log(
                '删除否？',
                isExist,
                v.isSync,
                files,
                files.data?.list,
                notes.list
              )
              thunkAPI.dispatch(
                notesSlice.actions.deleteNote({
                  noteId: v?.id || '',
                })
              )
              // alert({
              // 	title: '删除否？',
              // 	content: '删除否？',
              // 	cancelText: 'Cancel',
              // 	confirmText: 'Delete',
              // 	onCancel() {
              // 		// store.dispatch(
              // 		// 	notesSlice.actions.addNote({
              // 		// 		v: {
              // 		// 			...note,
              // 		// 			id: uuidv5(note.name, uuidv4()),
              // 		// 			authorId: user.userInfo.uid,
              // 		// 			isSync: false,
              // 		// 		},
              // 		// 		disableSync: true,
              // 		// 	})
              // 		// )
              // 	},
              // 	onConfirm() {
              // 	},
              // }).open()
            } else {
              // store.dispatch(
              //   notesSlice.actions.setNoteLastUpdateTime({
              //     id: v.id || "",
              //     lastUpdateTime: Math.floor(new Date().getTime() / 1000),
              //     syncTime: Math.floor(new Date().getTime() / 1000),
              //   })
              // )
              api.v1
                .syncToServer({
                  type: 'Note',
                  methods: 'Add',
                  options: {
                    noteId: v.id,
                  },
                  data: {
                    note: v,
                  },
                })
                .then((res) => {
                  // console.log(res)
                })
            }
          }
        })
      } else {
        if (files.code === 10004) {
          thunkAPI.dispatch(userSlice.actions.setStatus(0))
        }
      }
      store.dispatch(
        configSlice.actions.setStatus({
          type: 'syncStatus',
          v: false,
        })
      )
    }
  ),
  GetCollaborativeNotes: createAsyncThunk(
    'notes/GetCollaborativeNotes',
    async (_, thunkAPI) => {
      console.log('------GetCollaborativeNotes------')
      const { config, notes, user } = store.getState()
      console.log('开始了同步功能')

      store.dispatch(
        configSlice.actions.setStatus({
          type: 'syncStatus',
          v: true,
        })
      )

      const promiseAll: any[] = []

      notes.list.forEach((v) => {
        // if (v.authorId !== user.userInfo.uid) {
        promiseAll.push(
          new Promise(async (res, rej) => {
            const npRes = await httpApi.v1.GetNotePermissions({
              noteId: v.id || '',
            })
            console.log('GetNotePermissions', v, npRes)
            if (npRes.code === 200 && v.authorId !== user.userInfo.uid) {
              if (
                npRes.data?.list?.filter(
                  (v) =>
                    v.authorId === user.userInfo.uid &&
                    Number(v.permission) >= 1
                )?.length &&
                v.isSync
              ) {
                getNoteByCloud(v.id || '')
              }
            }
            if (npRes.code === 10004) {
              thunkAPI.dispatch(userSlice.actions.setStatus(0))
            }
            res(npRes?.data?.list)
          })
        )
        // }
      })

      const res = await Promise.all(promiseAll)

      thunkAPI.dispatch(
        notesSlice.actions.setPermissions(
          Object.fromEntries(
            res.filter((v) => v?.length).map((v) => [v?.[0]?.noteId || '', v])
          )
        )
      )

      store.dispatch(
        configSlice.actions.setStatus({
          type: 'syncStatus',
          v: false,
        })
      )
    }
  ),
  AddNotebook: createAsyncThunk<
    void,
    void,
    {
      state: RootState
    }
  >('notes/AddNotebook', async (_, thunkAPI) => {
    let name = ''
    const i18n = getI18n()
    prompt({
      value: '',
      title: i18n.t('addNotebook', {
        ns: 'indexPage',
      }),
      placeholder: i18n.t('placeholder', {
        ns: 'indexPage',
      }),
      cancelText: i18n.t('cancel', {
        ns: 'common',
      }),
      confirmText: i18n.t('create', {
        ns: 'common',
      }),
      onChange(e) {
        name = e
        return ''
      },
      onCancel() {},
      onConfirm() {
        const { notes, user, config } = thunkAPI.getState()

        const note: protoRoot.note.INoteItem = {
          id: getId(),
          name: name,
          createTime: Math.floor(new Date().getTime() / 1000),
          lastUpdateTime: Math.floor(new Date().getTime() / 1000),
          syncTime: 0,
          sort: (notes.list[notes.list?.length - 1]?.sort || 0) + 1,
          isSync: user.isLogin,
          categories: [],
          authorId: user.userInfo.uid,
          version: config.version,

          status: 1,
          deleteTime: -1,
          deleteUserId: [],
          localUpdateTime: -1,
        }

        thunkAPI.dispatch(
          notesSlice.actions.addNote({
            v: note,
          })
        )
      },
    }).open()
  }),
  AddCategory: createAsyncThunk(
    'notes/AddCategory',
    async ({ noteId }: { noteId: string }, thunkAPI) => {
      let name = ''
      const i18n = getI18n()
      prompt({
        value: '',
        title: i18n.t('addCategory', {
          ns: 'indexPage',
        }),
        placeholder: i18n.t('categoryName', {
          ns: 'indexPage',
        }),
        cancelText: i18n.t('cancel', {
          ns: 'common',
        }),
        confirmText: i18n.t('add', {
          ns: 'common',
        }),
        onChange(e) {
          name = e
          return ''
        },
        onCancel() {},
        onConfirm() {
          if (!name) {
            snackbar({
              message: i18n.t('categoryNameNil', {
                ns: 'indexPage',
              }),
              vertical: 'top',
              horizontal: 'center',
              autoHideDuration: 2000,
              closeIcon: true,
            }).open()
            return
          }
          thunkAPI.dispatch(
            notesSlice.actions.addCategory({
              noteId,
              category: {
                id: getId(),
                name: name,
                createTime: Math.floor(new Date().getTime() / 1000),
                lastUpdateTime: Math.floor(new Date().getTime() / 1000),
                sort: 0,
                data: [],

                status: 1,
                deleteTime: -1,
                deleteUserId: [],
                localUpdateTime: -1,
              },
            })
          )
        },
      }).open()
      return ''
    }
  ),
  AddPage: createAsyncThunk(
    'notes/AddPage',
    async (
      {
        noteId,
        categoryId,
        type,
      }: {
        noteId: string
        categoryId: string
        type: PageItem['type']
      },
      thunkAPI
    ) => {
      thunkAPI.dispatch(
        notesSlice.actions.addPage({
          noteId,
          categoryId,
          page: {
            id: getId(),
            title: '',
            content: '',
            type,
            createTime: Math.floor(new Date().getTime() / 1000),
            lastUpdateTime: Math.floor(new Date().getTime() / 1000),
            sort: 0,
            encryption: -1,

            status: 1,
            deleteTime: -1,
            deleteUserId: [],
            localUpdateTime: -1,
          },
        })
      )
      return ''
    }
  ),
  // UpdatePage: createAsyncThunk(
  //   'notes/UpdatePage',
  //   (
  //     payload: {
  //       noteId: string
  //       categoryId: string
  //       pageId: string
  //       data: {
  //         title?: string
  //         // type?: PageItem['type']
  //         content?: string
  //       }
  //     },
  //     thunkAPI
  //   ) => {
  //     thunkAPI.dispatch(
  //       notesSlice.actions.updatePage({
  //         noteId: payload.noteId,
  //         categoryId: payload.categoryId,
  //         pageId: payload.pageId,
  //         data: payload.data,
  //       })
  //     )
  //   }
  // ),
  SyncData: createAsyncThunk(
    'notes/SyncData',
    (payload: protoRoot.sync.SyncData.IResponse, thunkAPI) => {
      // thunkAPI.dispatch(notesSlice.actions.updatePage(payload))
      console.log('SyncData payload 版本', payload)

      const { notes } = store.getState()

      const pl: any = payload

      const noteId = pl.options?.noteId || ''
      const categoryId = pl.options?.categoryId || ''
      const pageId = pl.options?.pageId || ''
      const todoId = pl.options?.todoId || ''

      if (!notes.list.filter((v) => v.id === noteId)?.[0]?.isSync) {
        return
      }

      store.dispatch(
        notesSlice.actions.setNoteLastUpdateTime({
          id: pl.options?.noteId || '',
          lastUpdateTime: payload.lastUpdateTime || 0,
          syncTime: payload.lastUpdateTime || 0,
        })
      )

      switch (payload.type) {
        case 'Note':
          switch (payload.methods) {
            case 'Add':
              thunkAPI.dispatch(
                notesSlice.actions.addNote({
                  v: { ...pl.data?.note, isSync: true },
                  disableSync: true,
                })
              )
              break
            case 'Update':
              thunkAPI.dispatch(
                notesSlice.actions.updateNote({
                  noteId: pl.options?.noteId || '',
                  changedField: pl?.changedField || [],
                  note: {
                    name: pl.data?.note?.name || '',
                    categories: pl.data?.note?.categories || undefined,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Delete':
              thunkAPI.dispatch(
                notesSlice.actions.deleteNote({
                  noteId: pl.options?.noteId,
                  data: {
                    deleteTime: pl.data?.note?.deleteTime,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Sort':
              thunkAPI.dispatch(
                notesSlice.actions.sortNote({
                  sort: pl.data.sort,
                  disableSync: true,
                })
              )
              break

            default:
              break
          }

          break
        case 'Category':
          switch (payload.methods) {
            case 'Add':
              thunkAPI.dispatch(
                notesSlice.actions.addCategory({
                  noteId: pl.options.noteId,
                  category: {
                    ...pl.data?.category,
                    title: pl.data?.category.name || '',
                  },
                  disableSync: true,
                })
              )
              break
            case 'Update':
              thunkAPI.dispatch(
                notesSlice.actions.updateCategory({
                  noteId: pl.options?.noteId,
                  categoryId: pl.options?.categoryId,
                  category: {
                    name: pl.data?.category.name,
                    data: pl.data?.category.data,
                    lastUpdateTime: pl.data?.category.lastUpdateTime,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Delete':
              thunkAPI.dispatch(
                notesSlice.actions.deleteCategory({
                  noteId: pl.options.noteId,
                  categoryId: pl.options.categoryId,
                  data: {
                    deleteTime: pl.data?.category?.deleteTime,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Sort':
              thunkAPI.dispatch(
                notesSlice.actions.sortCategory({
                  noteId: pl.options.noteId,
                  lastUpdateTime: pl.data?.note?.lastUpdateTime,
                  sort: pl.data.sort,
                  disableSync: true,
                })
              )
              break

            default:
              break
          }

          break
        case 'Page':
          switch (payload.methods) {
            case 'Add':
              thunkAPI.dispatch(
                notesSlice.actions.addPage({
                  noteId: pl.options.noteId,
                  categoryId: pl.options.categoryId,
                  page: {
                    ...pl.data?.page,
                    title: pl.data?.page.title || '',
                    content: pl.data?.page.content || '',
                  },
                  disableSync: true,
                })
              )
              break
            case 'Delete':
              thunkAPI.dispatch(
                notesSlice.actions.deletePage({
                  noteId: pl.options.noteId,
                  categoryId: pl.options.categoryId,
                  pageId: pl.options.pageId,
                  data: {
                    deleteTime: pl.data?.page?.deleteTime,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Sort':
              thunkAPI.dispatch(
                notesSlice.actions.sortPage({
                  noteId: pl.options.noteId,
                  categoryId: pl.options.categoryId,
                  lastUpdateTime: pl.data?.category?.lastUpdateTime,
                  sort: pl.data.sort,
                  disableSync: true,
                })
              )
              break
            case 'Update':
              thunkAPI.dispatch(
                notesSlice.actions.updatePage({
                  noteId: pl.options.noteId,
                  categoryId: pl.options.categoryId,
                  pageId: pl.options.pageId,
                  changedField: pl.changedField,
                  data: {
                    ...pl.data?.page,
                  },
                  disableSync: true,
                })
              )

              // lastSyncTimeDebounce.increase(() => {
              //   thunkAPI.dispatch(
              //     notesSlice.actions.setLastSyncTime(
              //       Math.floor(new Date().getTime() / 1000)
              //     )
              //   )
              // }, 300)
              break

            default:
              break
          }

          break

        case 'TodoList':
          switch (payload.methods) {
            case 'Add':
              thunkAPI.dispatch(
                notesSlice.actions.addTodo({
                  noteId,
                  categoryId,
                  pageId,
                  todo: {
                    ...pl.data?.todo,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Delete':
              thunkAPI.dispatch(
                notesSlice.actions.deleteTodo({
                  noteId,
                  categoryId,
                  pageId,
                  todoId,
                  data: {
                    deleteTime: pl.data?.todo?.deleteTime,
                  },
                  disableSync: true,
                })
              )
              break
            case 'Sort':
              thunkAPI.dispatch(
                notesSlice.actions.sortTodo({
                  noteId,
                  categoryId,
                  pageId,
                  lastUpdateTime: pl.data?.page?.lastUpdateTime,
                  sort: pl.data.sort,
                  disableSync: true,
                })
              )
              break
            case 'Update':
              thunkAPI.dispatch(
                notesSlice.actions.updateTodo({
                  noteId,
                  categoryId,
                  pageId,
                  todoId,
                  data: {
                    ...pl.data?.todo,
                  },
                  disableSync: true,
                })
              )

              // lastSyncTimeDebounce.increase(() => {
              //   thunkAPI.dispatch(
              //     notesSlice.actions.setLastSyncTime(
              //       Math.floor(new Date().getTime() / 1000)
              //     )
              //   )
              // }, 300)
              break

            default:
              break
          }

          break

        default:
          break
      }

      if (
        payload.type === 'TodoList' ||
        (payload.type === 'Page' && payload.methods === 'Update')
      ) {
        thunkAPI.dispatch(notesSlice.actions.updateNoteTime())
      }
    }
  ),
  EnableSyncNote: createAsyncThunk<
    void,
    {
      noteId: string
      isSync: boolean
    },
    {
      state: RootState
    }
  >('notes/EnableSyncNote', async ({ noteId, isSync }, thunkAPI) => {
    console.log('------EnableSyncNote------')
    thunkAPI.dispatch(
      notesSlice.actions.enableSyncNote({
        noteId,
        isSync,
      })
    )
    if (isSync) {
      let note = thunkAPI
        .getState()
        .notes.list.filter((v) => v.id === noteId)?.[0]
      const res = await api.v1.getUrls({
        noteId,
      })
      console.log(res, 'getUrls')
      // 存在就更新，不存在則創建
      if (res.code === 200) {
        await getNoteMergeOrReplaceAlert(noteId)
      } else if (res.code === 10020) {
        api.v1
          .syncToServer({
            type: 'Note',
            methods: 'Add',
            options: {
              noteId: noteId,
            },
            data: {
              note: note,
            },
          })
          .then((res) => {})
      } else {
        console.log(res)
      }
    }
  }),
}
